import React, { useState } from "react";

const Form = () => {
  // For Captcha code
  const randomString = Math.random().toString(36).slice(8);
  const [captcha, setCaptcha] = useState(randomString);
  const [text, setText] = useState("");
  const [valid] = useState(false);

  const [EASYTDS, setEASYTDS] = useState({
    name: "",
    mobile: "",
    mobile2: "",
    email: "",
    address1: "",
    address2: "",
    area: "",
    city: "",
    state: "",
    pin_code: "",
    description: "",
    profession: "",
    product: "EASYOFFICE",
    sub_product: "EASYTDS",
  });

  const handlechange = (e) => {
    const { name, value } = e.target;
    setEASYTDS({
      ...EASYTDS,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const Authanantication = btoa("electrocom:electrocom");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${Authanantication}`,
      },
      body: JSON.stringify(EASYTDS),
    };

    fetch("http://espl.local:8080/espl/api/send-inquiry", requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((EASYTDS) => {
        console.log("Form submitted successfully:", EASYTDS);
        alert("Thank you For Messageing");
        setCaptcha(Math.random().toString(36).slice(8));
        setText("");
        setEASYTDS({
          product: "EASYOFFICE",
          sub_product: "EASYTDS",
          name: "",
          mobile: "",
          mobile2: "",
          email: "",
          address1: "",
          address2: "",
          area: "",
          city: "",
          state: "",
          pin_code: "",
          description: "",
          profession: "",
        });
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
      });
  };

  const fields = [
    {
      id: "name",
      name: "name",
      placeholder: "Full Name",
      type: "text",
    },
    {
      id: "profession",
      name: "profession",
      placeholder: "Profession",
      type: "text",
    },
    {
      id: "mobile",
      name: "mobile",
      placeholder: "Mobile Number",
      type: "text",
    },
    { id: "email", name: "email", placeholder: "Email", type: "email" },
    {
      id: "city",
      name: "city",
      placeholder: "City",
      type: "text",
    },
    // {
    //   id: "state",
    //   name: "state",
    //   placeholder: "State",
    //   type: "text",
    // },
    // {
    //   id: "description",
    //   name: "description",
    //   placeholder: "Remark",
    //   type: "text",
    //   extraClass: "pb-10",
    //   cols: "col-span-2",
    // },
  ];

  // For captcha code
  const refreshString = () => {
    setCaptcha(Math.random().toString(36).slice(8));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="p-6 bg-[#ffffff] border-2 rounded-xl shadow-xl">
        <div className="grid grid-cols-2 gap-3">
          {fields.map(
            ({ id, name, placeholder, type, extraClass, cols = "" }) => (
              <div className={`relative my-2 ${cols}`} key={id}>
                <input
                  id={id}
                  name={name}
                  placeholder={placeholder}
                  type={type}
                  value={EASYTDS[name]}
                  onChange={handlechange}
                  className={`border-b w-full border-gray-600 py-1 focus:border-b-2 focus:border-gray-900 placeholder-black transition-colors focus:outline-none bg-inherit ${extraClass}`}
                  required={id === "name" && "mobile" && "city"}
                />
              </div>
            )
          )}
          <div className={`relative`}>
            <select
              name="state"
              id="state"
              onChange={handlechange}
              required
              className={`border-b w-full border-gray-600 py-1 focus:border-b-2 focus:border-gray-900 placeholder-black transition-colors focus:outline-none bg-inherit`}
            >
              <optgroup className="bg-gray-50">
                <option value="1" className="border-gray-400">
                  State{" "}
                </option>
                <option value="39">Andaman and Nicobar Islands</option>
                <option value="2">Andhra Pradesh</option>
                <option value="3">Arunachal Pradesh</option>
                <option value="4">Assam</option>
                <option value="5">Bihar</option>
                <option value="6">Chandigarh</option>
                <option value="7">Chhattisgarh</option>
                <option value="8">Dadra and Nagar Haveli</option>
                <option value="9">Daman and Diu</option>
                <option value="10">Delhi-NCR</option>
                <option value="11">Goa</option>
                <option value="12">Gujarat</option>
                <option value="13">Haryana</option>
                <option value="14">Himachal Pradesh</option>
                <option value="15">Jammu and Kashmir</option>
                <option value="16">Jharkhand</option>
                <option value="17">Karnataka</option>
                <option value="18">Kenmore</option>
                <option value="19">Kerala</option>
                <option value="20">Lakshadweep</option>
                <option value="21">Madhya Pradesh</option>
                <option value="22">Maharashtra</option>
                <option value="23">Manipur</option>
                <option value="24">Meghalaya</option>
                <option value="25">Mizoram</option>
                <option value="26">Nagaland</option>
                <option value="27">Narora</option>
                <option value="28">Natwar</option>
                <option value="29">Odisha</option>
                <option value="30">Paschim Medinipur</option>
                <option value="31">Pondicherry</option>
                <option value="32">Punjab</option>
                <option value="33">Rajasthan</option>
                <option value="34">Sikkim</option>
                <option value="35">Tamil Nadu</option>
                <option value="36">Telangana</option>
                <option value="37">Tripura</option>
                <option value="38">West Bengal</option>
              </optgroup>
            </select>
          </div>
          <div className="relative col-span-2">
            <input
              id="description"
              name="description"
              // value={description}
              placeholder="Remark"
              onChange={handlechange}
              className={`border-b w-full pb-10 border-gray-600 py-1 focus:border-b-2 focus:border-gray-900 placeholder-black transition-colors focus:outline-none bg-inherit`}
            />
          </div>
        </div>
        {/* Captcha Code */}
        <div className="sm:flex items-center mt-3 py-2">
          <div className="flex items-center bg-gray-100 px-2 py-1">
            <div className="mr-2 text-black line-through text-4xl">
              {captcha}
            </div>
            <button onClick={() => refreshString()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="black"
                class="bi bi-arrow-clockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                />
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            </button>
          </div>
          <div className="sm:ml-4 mt-2 sm:mt-0">
            <textarea
              name="Enter Captcha"
              value={text}
              cols="15"
              rows="1"
              className="px-4 py-1 bg-[#f1f5f8]"
              placeholder="Enter Captcha..."
              error={valid}
              onChange={(e) => setText(e.target.value)}
              helperText={valid && "Invalid Captcha"}
            ></textarea>
          </div>
          <div>
            <p
              className={`mb-0 ml-3 text-black ${
                text.length > 0 ? "block" : "hidden"
              } ${text === captcha ? "hidden" : ""}`}
            >
              Enter Valid Captcha
            </p>
          </div>
        </div>
        <div className="mt-3">
          <button
            type="submit"
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={text !== captcha}
            className="px-6 py-2 bg-gradient-to-r from-[#686bff] to-[#00b812] text-white rounded-lg font-bold duration-200 transform hover:rounded-full hover:-translate-y-1 transition disabled:bg-gradient-to-r disabled:from-red-400 disabled:to-red-400 disabled:-translate-y-0 disabled:rounded-md disabled:opacity-80 disabled:cursor-not-allowed"
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default Form;
